import CategoryType from 'owa-service/lib/contract/CategoryType';
import { addCategoryToStore } from '../internal/addCategoryToStore';

/**
 * This function add the categories from the passed calendar if present to the store
 */
export const addCategoriesFromCalendar = (calendar: {
    remoteCategories?: { MasterList?: CategoryType[]; DefaultList?: CategoryType[] };
}) => {
    if (calendar && calendar.remoteCategories) {
        const { MasterList, DefaultList } = calendar.remoteCategories;
        addCategoriesToStore(DefaultList);
        addCategoriesToStore(MasterList);
    }
};

function addCategoriesToStore(categories: CategoryType[]) {
    categories?.forEach(category => {
        addCategoryToStore(category);
    });
}
